module.exports = __webpack_public_path__ + "static/media/whats-app.d6e11e58.svg";